export default __webpack_public_path__ + "static/media/element_44.4e1cdcee.webp";